import Button from 'components/gruenland/atoms/button/Button';
import Link from 'components/gruenland/atoms/link';
import { CheckoutButtonProps } from './types';

const CheckoutButton: React.FC<CheckoutButtonProps> = ({ className, link, disabled, text, onClick }) => {
  return (
    <div className={className}>
      <Link link={link}>
        <Button disabled={disabled} onClick={onClick} variant="buttonSecondaryNegative" className="w-full">
          {text}
        </Button>
      </Link>
    </div>
  );
};

export default CheckoutButton;
